module.exports = __webpack_public_path__ + "img/badge_color_txcan-finaid.e039148c.svg";